module.exports = __webpack_public_path__ + "static/out.fb4466af.svg";